// src/router/index.tsx
import { lazy, Suspense } from "react";
import { Switch, Route, useLocation, matchPath } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import routes from "./config";
import { Styles } from "../styles/styles";

const LoadingSpinner = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '50vh',
    color: '#666'
  }}>
    Loading...
  </div>
);

const noLayoutPaths = routes
  .filter((r) => r.noLayout)
  .flatMap((r) => (Array.isArray(r.path) ? r.path : [r.path]));

// Build lazy components ONCE at module scope. Calling lazy() inside the
// component's render created a new lazy on every render → Suspense fell
// back on every Router re-render → every component inside Suspense
// (Header, Footer, the page) unmounted briefly. That caused the mobile
// drawer to auto-dismiss when any ambient state change happened while
// it was open.
const lazyRoutes = routes.map((routeItem) => ({
  ...routeItem,
  Component: lazy(() => import(
    /* webpackChunkName: "[request]" */
    `../pages/${routeItem.component}`
  )),
}));

const Router = () => {
  const location = useLocation();
  const hideLayout = noLayoutPaths.some((p) =>
    matchPath(location.pathname, { path: p, exact: true })
  );

  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Styles />
      {!hideLayout && <Header />}
      <Switch>
        {lazyRoutes.map((routeItem) => (
          <Route
            key={routeItem.component}
            path={routeItem.path}
            exact={routeItem.exact}
            component={routeItem.Component}
          />
        ))}
      </Switch>
      {!hideLayout && <Footer />}
    </Suspense>
  );
};

export default Router;
